import { render } from "./SignatureBlock.vue?vue&type=template&id=acf0dd0e"
import script from "./SignatureBlock.vue?vue&type=script&lang=js"
export * from "./SignatureBlock.vue?vue&type=script&lang=js"

import "./SignatureBlock.vue?vue&type=style&index=0&id=acf0dd0e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__